import Loader from "@/atoms-react/loader/Loader.react";
import { useKYC } from "@/features/kyc/hooks/use-kyc";
import {
  CreateKYCDocument,
  type KYCSession,
  KYCSessionScenario,
  KYCSessionType
} from "@/features/kyc/types";
import type { UserType } from "@/features/user/types";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { KYCSessionIFrame } from "@/molecules/kyc-session-iframe/index.react";
import { useEffect, useState } from "react";

type QuestionScenarioProps = {
  custom_scenario?: boolean;
  user?: UserType;
  onValidated: (data: CreateKYCDocument) => Promise<void>;
  documentType?: string;
};
//
export const QuestionScenario = ({
  user,
  onValidated,
  custom_scenario = false,
  documentType
}: QuestionScenarioProps) => {
  const { getLanguage } = usei18n();
  const { createKYCSessionMutation } = useKYC();
  const { mutateAsync: createKYCSession } = createKYCSessionMutation();
  const [KYCSessionState, setKYCSessionState] = useState<KYCSession | null>(null);

  const executeCreateKYCSession = async () => {
    if (!user) return;
    const scenario = custom_scenario
      ? KYCSessionScenario.Fusion
      : navigator.userAgent === "Cypress-Olky"
        ? KYCSessionScenario.Question_e2e
        : KYCSessionScenario.Question;
    const response = await createKYCSession({
      UUID: user.naturalPerson.UUID ?? "",
      language: getLanguage(),
      sessionSenario: scenario,
      sessionType: custom_scenario ? KYCSessionType.Fusion : KYCSessionType.Question,
      documentType: documentType,
      // temp fix for user naturalPerson because DateOfBirth is not the same format as intended
      naturalPerson: {
        ...user.naturalPerson,
        DateOfBirth: {
          ...user.naturalPerson.DateOfBirth,
          date: user.naturalPerson.DateOfBirth.date.substring(0, 10)
        }
      }
    });
    setKYCSessionState(response);
  };

  useEffect(() => {
    if (!KYCSessionState) {
      executeCreateKYCSession();
    }
  }, []);

  return (
    <>
      {!KYCSessionState && (
        <div className="mb-4 flex flex-1 items-center justify-center">
          <Loader className="text-gray-500" />
        </div>
      )}
      {KYCSessionState && (
        <KYCSessionIFrame
          className={"h-[80vh]"}
          naturalPersonUUID={user?.naturalPerson.UUID}
          custom_scenario={custom_scenario}
          KYCSessionState={KYCSessionState}
          params={{ powered_by: false, show_consent: false, show_home: false, show_final: false }}
          onValidated={onValidated}
        />
      )}
    </>
  );
};
